import { Spacer } from './ColorPreview';
import {
  Column,
  Font,
  PrimaryButton,
  Row,
  ThinBorderStyle,
} from './DesignSystem';
import { Palette } from './Palette';

export function Plans() {
  function Plan({
    name,
    description,
    price,
  }: {
    name: string;
    description: string;
    price: number;
  }) {
    return (
      <Column style={{ ...ThinBorderStyle, padding: 8 }}>
        <div style={{ marginBlockEnd: '4px' }}>
          <Font kind="font-body">{name}</Font>
        </div>
        <div style={{ marginBlockEnd: '4px' }}>
          <Font kind="font-caption">{description}</Font>
        </div>
        <div style={{ marginBlockEnd: '4px' }}>{`$${price / 100}`}</div>
        <PrimaryButton text="Upgrade" onClick={() => {}} />
      </Column>
    );
  }

  return (
    <Row style={{ gap: 8 }}>
      <Plan name="Starter" description="The basics, bitch!" price={199999} />
      <Plan name="Starter" description="The basics, bitch!" price={199999} />
      <Plan name="Starter" description="The basics, bitch!" price={199999} />
    </Row>
  );
}

function TextCell({ text }: { text: string }) {
  return (
    <div>
      <Font kind="font-body">{text}</Font>
    </div>
  );
}

function Heading({ text }: { text: string }) {
  return (
    <div>
      <Font kind="font-subtitle">{text}</Font>
    </div>
  );
}

export function AuthenticationMethodsTable() {
  return (
    <Column
      style={{ ...ThinBorderStyle, padding: '4px', backgroundColor: 'white' }}
    >
      <Row style={{ backgroundColor: '#fafafa', marginBlockEnd: '4px' }}>
        <Heading text="Supported Authentication" />
      </Row>
      <Row
        style={{ paddingBlock: '4px', borderBottom: ThinBorderStyle.border }}
      >
        <TextCell text="Email" />
        <Spacer />
        <input type="checkbox" />
      </Row>
      <Row
        style={{ paddingBlock: '4px', borderBottom: ThinBorderStyle.border }}
      >
        <TextCell text="Sign in with Apple" />
        <Spacer />
        <input type="checkbox" />
      </Row>
      <Row style={{ paddingBlock: '4px' }}>
        <TextCell text="Sign in with Google" />
        <Spacer />
        <input type="checkbox" />
      </Row>
    </Column>
  );
}

export type Cell =
  | { type: 'heading'; text: string }
  | { type: 'textCell'; text: string };
export type Row =
  | { type: 'heading'; heading: Extract<Cell, { type: 'heading' }> }
  | { type: 'preference'; name: string };

export function Table({
  rows,
  renderRow,
}: {
  rows: Row[];
  renderRow: (_: React.PropsWithChildren<{ row: Row }>) => React.Node;
}) {
  return (
    <Column>
      {rows.map((row, i) => {
        function Content() {
          switch (row.type) {
            case 'heading':
              return <Heading text={row.heading.text} />;
            case 'preference':
              return (
                <>
                  <TextCell text={row.name} />
                  <Spacer />
                  <input type="checkbox" />
                </>
              );
          }
        }
        return (
          <div key={i}>{renderRow({ row: row, children: <Content /> })}</div>
        );
      })}
    </Column>
  );
}

export function StorageMethodsTable() {
  return (
    <Table
      rows={[
        {
          type: 'heading',
          heading: { text: 'Data Storage' },
        },
        { type: 'preference', name: 'Local' },
        { type: 'preference', name: 'iCloud' },
        { type: 'preference', name: 'Supabase' },
      ]}
      renderRow={({ row, children }) => {
        return (
          <Row
            style={{
              width: '100%',
              backgroundColor: row.type === 'heading' ? '#FAFAFA' : '#FFFFFF',
            }}
          >
            {children}
          </Row>
        );
      }}
    ></Table>
  );
}

export function BackendPalette({}) {
  return (
    <Palette title="Connect" windowID="connect">
      <Column style={{ gap: '8px' }}>
        <AuthenticationMethodsTable />
        <StorageMethodsTable />
      </Column>
    </Palette>
  );
}
